import { render, staticRenderFns } from "./UseRule.vue?vue&type=template&id=8d00eebc&scoped=true"
import script from "./UseRule.vue?vue&type=script&lang=js"
export * from "./UseRule.vue?vue&type=script&lang=js"
import style0 from "./UseRule.vue?vue&type=style&index=0&id=8d00eebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d00eebc",
  null
  
)

export default component.exports